import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from "react-helmet-async";
import store  from './store/store';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
    <Provider store={store}>
      <App />
      <ToastContainer />
  </Provider>
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
reportWebVitals();
